import { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css";
import { useAuth } from "../context/AuthContext";
import { loginApi } from "../api/api";
import { saveUserData } from "../utils/authStorage";
import logo from "../resources/logo.png";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  const validationSchema = Yup.object({
    username: Yup.string().required("User Name is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
  });

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    console.log("Login data:", values);
    // TODO: call API login here
    setSubmitting(false);
    try {
      const data = await loginApi(values.username, values.password);
      console.log("data", data, data.token);
      if (data.isSuccess) {
        localStorage.setItem("token", data.token); // save token
        saveUserData({
          user: data.user,
        });
        login(); // update auth context
        navigate("/dashboard");
      } else {
        setErrors({ password: data.message });
      }
    } catch (err) {
      setErrors({ password: "Invalid username or password" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src={logo} alt="admin" className="login-icon" />
        <h2 className="login-title">Admin Login</h2>
        <Formik
          initialValues={{ username: "", password: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="login-form">
              {/* Email Field */}
              <div className="form-group">
                <label>User Name</label>
                <div className="input-wrapper">
                  <span className="input-icon">
                    <FaEnvelope />
                  </span>
                  <Field
                    type="username"
                    name="username"
                    placeholder="Enter your username"
                  />
                </div>
                <ErrorMessage
                  name="username"
                  component="div"
                  className="error"
                />
              </div>

              {/* Password Field */}
              <div className="form-group">
                <label>Password</label>
                <div className="input-wrapper">
                  <span className="input-icon">
                    <FaLock />
                  </span>
                  <Field
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Enter your password"
                  />
                  <span
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                <ErrorMessage
                  name="password"
                  component="div"
                  className="error"
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="btn-login"
              >
                {isSubmitting ? "Logging in..." : "Login"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Login;
